import lazyLoad from '@utils/lazyLoad'

const interactionRoutes = [
  // 互动列表
  {
    path: '/marketing/interaction',
    exact: true,
    component: lazyLoad(() => import('@views/Marketing/Interaction'))
  },
  // 新建互动
  {
    path: '/marketing/interaction/new',
    exact: true,
    component: lazyLoad(() => import('@views/Marketing/Interaction/new')),
    meta: {
      title: '互动新建'
    }
  },
  // 新建编辑
  {
    path: '/marketing/interaction/edit/:id',
    exact: true,
    component: lazyLoad(() => import('@views/Marketing/Interaction/new')),
    meta: {
      title: '互动编辑'
    }
  },
  // 互动详情
  {
    path: '/marketing/interaction/detail/:id/:key',
    exact: true,
    component: lazyLoad(() => import('@views/Marketing/Interaction/detail')),
    meta: {
      title: '互动详情'
    }
  }
]

export default interactionRoutes
